import React from "react";
import wordmark from "@/assets/brand/the-training-ground-logo.png";
import mark from "@/assets/brand/the-training-ground-mark.png";

// Central brand component. Two variants map to the two supplied assets:
//   - "wordmark" → full "the training ground" lockup
//   - "mark"     → compact "tg" hero mark
// The supplied artwork is authoritative — this component only sizes and
// positions it. No gradients, no shadows, no restyling.
export const Logo = ({
  variant = "wordmark",
  height,             // number (px) — preferred, keeps aspect ratio exact
  className = "",
  alt,
  ...rest
}) => {
  const isMark = variant === "mark";
  const src = isMark ? mark : wordmark;
  const defaultAlt = isMark ? "TG" : "The Training Ground";
  return (
    <img
      src={src}
      alt={alt ?? defaultAlt}
      draggable={false}
      className={"select-none " + className}
      style={{
        height: height ? `${height}px` : undefined,
        width: "auto",
        ...(rest.style || {}),
      }}
      {...rest}
    />
  );
};

export default Logo;
